import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as NotificationActions from 'rebook/apps/users/actions/NotificationActions';
import { USERS_AUTH_LOGIN_NOTIFICATIONS } from 'rebook/apps/users/constants';
import Form, { FormControl, FormRow } from 'rebook/apps/base/components/form/Form';
import Button from 'rebook/apps/base/components/Button';
import FormTextInput from 'rebook/apps/base/components/form/FormTextInput';
import validateForm from 'rebook/apps/base/components/form/validateForm';

import styles from './style.scss';


class SetNewPasswordView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorList: {},
      form: {},
      isDisabled: false,
      isSuccess: false,
    };
  }

  updateFormField(input) {
    this.setState((prevState) => {
      return {
        errorList: {},
        form: {
          ...prevState.form,
          ...input,
        },
      };
    });
  };

  handleFormSubmit(submit) {
    this.setState({
      errorList: {},
      isDisabled: true,
    });
    const form = validateForm(this.state.form);
    submit(form);
  }

  handleSuccess() {
    window.scrollTo(0, 0);
    this.props.NotificationActions.pop(USERS_AUTH_LOGIN_NOTIFICATIONS.RESET_PASSWORD_SUCCESS);
    this.setState({
      errorList: {},
      isDisabled: false,
      isSuccess: true,
    });
    this.props.history.push('/');
  }

  handleError(errorList) {
    this.setState({
      errorList,
      isDisabled: false,
      isSuccess: false,
    });
  }

  render() {
    const { errorList, isDisabled } = this.state;
    return (
      <div className="section">
        <div className={styles.container}>
          <div className="title-2">Придумайте пароль</div>
          <div className={styles.text}>
            Пожалуйста, придумайте новый пароль, чтобы в дальнейшем не испытывать проблем при входе.
          </div>
          <div className={styles.form}>
            <Form
              extraClassName="jest-set-password-form"
              action="/api/account/set-password/"
              method="post"
              onSubmit={(callback) => this.handleFormSubmit(callback)}
              onSuccess={(successList) => this.handleSuccess(successList)}
              onError={(errorList) => this.handleError(errorList)}>
              <div>
                <FormRow>
                  <FormTextInput
                    extraClassName="jest-set-password-input"
                    name="new_password"
                    type="password"
                    isRequired
                    errorList={errorList.new_password || errorList.non_field_errors}
                    onUpdate={(input) => this.updateFormField(input)}
                    isRequiredError="Ведите новый пароль"
                    isDisabled={isDisabled}
                    label="Придумайте новый пароль" />
                </FormRow>
                <FormControl extraClassName="jest-set-password-submit">
                  <Button isInProgress={isDisabled}>
                    Сохранить пароль
                  </Button>
                </FormControl>
              </div>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    NotificationActions: bindActionCreators(NotificationActions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(SetNewPasswordView);
